import { I_QREditorFormTemplate } from "@/data/types/pages";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { isClient } from "../browser";
import { qrNameValidation } from "./shared";
import { TFunction } from "i18next";

export const qrWifiValidation = (data: I_QREditorFormTemplate, t: TFunction) => {
  let formattedRule = true;
  if (isClient()) {
    //Validate if qrNetworkSecurityType is selected to set required validation of password
    const networkSecurityTypeValue = (<HTMLInputElement>(
      document.getElementById("qrNetworkSecurityType")
    ))?.value;
    if (networkSecurityTypeValue === "No password") formattedRule = false;
  }
  return [
    qrNameValidation(t),
    {
      name: "qrNetworkName",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("qrNetworkName", "required", data),
        },
        minLength: {
          value: 1,
          message: getRuleErrorMessage("qrNetworkName", "minLength", data),
        },
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("qrNetworkName", "maxLength", data),
        },
      },
    },
    {
      name: "qrNetworkPassword",
      rules: {
        required: {
          value: formattedRule,
          message: getRuleErrorMessage("qrNetworkPassword", "required", data),
        },
        maxLength: {
          value: 100,
          message: getRuleErrorMessage("qrNetworkPassword", "maxLength", data),
        },
      },
    },
    {
      name: "qrNetworkSecurityType",
      rules: {
        required: {
          value: true,
          message: getRuleErrorMessage("qrNetworkSecurityType", "required", data),
        },
      },
    },
  ];
};
